import { render } from "./JuniorMath.vue?vue&type=template&id=fff2bf44&ts=true"
import script from "./JuniorMath.vue?vue&type=script&lang=ts"
export * from "./JuniorMath.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__